import { RefreshIcon, StyledIconButton } from "@aureskonnect/react-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import ReactSwitch from "react-switch";
import { useSnapshot } from "valtio";

import {
    setIsBackgroundActive,
    setProjectFiles,
    setIsPageBackgroundActive,
    setIsPageTopBannerActive,
    generalConfigStore,
    setIsOrderTakingTopBannerActive,
    setFiles,
} from "@store";

import { Uploader } from "@components/Uploader";

import "@pages/GeneralConfig/Design/index.css";

export function General(): JSX.Element {
    const { t } = useTranslation();

    const {
        project: { template },
        files,
        imageKey,
        isOrderTakingTopBannerActive,
    } = useSnapshot(generalConfigStore);

    const background = (template.pages.ways[
        "orderTaking"
    ] as OrderTakingPageType).background;

    const [
        isBackgroundFinalActive,
        setIsBackgroundFinalActive,
    ] = React.useState(background.active);

    let getContentBackground;
    const image = files.filter(
        (element) => element.id === (background.id as string)
    )[0];
    if (image !== undefined) {
        const imageIndex = files.indexOf(image);
        getContentBackground = files[imageIndex];
    }

    function handleResetImagesOnClickEvent(id: string) {
        const imagesArray = [...files];

        const image = imagesArray.find((element) => element.id === id);
        if (image !== undefined) {
            const imageIndex = imagesArray.indexOf(image);

            imagesArray[imageIndex] = {
                ...image,
                content: imagesArray[imageIndex].defaultImage as string,
            };
        }
        setFiles(imagesArray);
        setProjectFiles(imagesArray);
    }

    function handleIsBackgroundActiveSwitchOnClickEvent() {
        setIsBackgroundFinalActive(!isBackgroundFinalActive);
        setIsBackgroundActive(!isBackgroundFinalActive);
        setIsPageBackgroundActive(!isBackgroundFinalActive, "orderTaking");
    }

    function handleIsTopBannerActiveSwitchOnClickEvent() {
        setIsOrderTakingTopBannerActive(!isOrderTakingTopBannerActive);
        setIsPageTopBannerActive(!isOrderTakingTopBannerActive, "orderTaking");
    }

    return (
        <div
            className="mt-4 rounded border"
            style={{ width: "93%", height: "96%", borderColor: "#CECECE" }}
        >
            <div
                className="text-left px-4 d-flex align-items-center cursor__clz"
                style={{
                    backgroundColor: "#EDEDED",
                    height: "40px",
                    fontSize: "20px",
                }}
            >
                {t("General")}
            </div>
            <div
                className="p-4 d-flex flex-column justify-content-between"
                style={{ gap: "20px" }}
            >
                <div
                    className="align-items-center"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "242px 241px auto",
                    }}
                >
                    <label>{t("General background")}</label>
                    <div
                        className="d-flex flex-row align-items-center justify-content-start"
                        style={{ gap: "10px" }}
                    >
                        <StyledIconButton
                            title={t("Reset")}
                            className="m-0"
                            icon="RefreshIcon"
                            onClick={() => {
                                handleResetImagesOnClickEvent(
                                    background.id as string
                                );
                            }}
                            disabled={
                                isBackgroundFinalActive === true ? false : true
                            }
                        >
                            <RefreshIcon height={15} width={15} />
                        </StyledIconButton>
                        <Uploader
                            key={imageKey}
                            uploadedFileTitle={
                                isBackgroundFinalActive === true
                                    ? (getContentBackground?.content as string) ===
                                      (getContentBackground?.defaultContent as string)
                                        ? undefined
                                        : (background.content as string)
                                    : undefined
                            }
                            id={background.id}
                            disabled={
                                isBackgroundFinalActive === true ? false : true
                            }
                        />
                    </div>
                    <div className="d-flex justify-content-end">
                        <ReactSwitch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            handleDiameter={26}
                            offColor="#f7b4b8"
                            offHandleColor="#E30613"
                            checked={isBackgroundFinalActive}
                            onChange={
                                handleIsBackgroundActiveSwitchOnClickEvent
                            }
                            onColor="#c2eddd"
                            onHandleColor="#34C38F"
                            width={50}
                            height={20}
                        />
                    </div>
                </div>
                <div
                    className="align-items-center"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                    }}
                >
                    <label>{t("Banner")}</label>

                    <div className="d-flex justify-content-end">
                        <ReactSwitch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            handleDiameter={26}
                            offColor="#f7b4b8"
                            offHandleColor="#E30613"
                            checked={isOrderTakingTopBannerActive}
                            onChange={() => {
                                handleIsTopBannerActiveSwitchOnClickEvent();
                            }}
                            onColor="#c2eddd"
                            onHandleColor="#34C38F"
                            width={50}
                            height={20}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
